import React from "react";

// Frame oficial ZEFERIUS: a imagem PNG do produto (fundo transparente) é encaixada
// na janela escura do frame e o preço fica dentro da placa dourada inferior.
// Medidas em % sobre a arte 1176x1337.
export const FRAME_RATIO = "1176/1337";
const WINDOW = { left: "32.5%", top: "12.5%", width: "35%", height: "47%" };
const PLATE = { left: "24%", top: "66.5%", width: "52%", height: "15.5%" };

export default function FramedProductImage({ image, name, price, adjust, priceDy = 0, priceDx = 0, priceScale = 1, priceColor = "#241600", priceWidth = 52, priceHeight = 6, priceRadius = 2, hoverZoom = true, testid }) {
  const fit = adjust?.fit === "cover" ? "cover" : "contain";
  const tx = adjust?.x || 0;
  const ty = adjust?.y || 0;
  const sc = adjust?.scale || 1;
  const hasAdjust = fit === "cover" || tx !== 0 || ty !== 0 || sc !== 1;
  const plateTop = Math.min(80, Math.max(52, 66.5 + (priceDy || 0)));
  const width = Math.min(60, Math.max(24, priceWidth || 52));
  const height = Math.min(14, Math.max(3, priceHeight || 6));
  const dx = Math.min(20, Math.max(-20, priceDx || 0));
  const plate = { left: `${50 - width / 2 + dx}%`, top: `${plateTop}%`, width: `${width}%`, height: "15.5%" };
  const plateBg = {
    left: "0", right: "0",
    top: `${(15.5 - height) / 2 / 15.5 * 100}%`,
    height: `${(height / 15.5) * 100}%`,
  };
  return (
    <div className="relative w-full" style={{ aspectRatio: FRAME_RATIO, containerType: "inline-size" }} data-testid={testid}>
      <img
        src="/assets/card-frame.png"
        alt=""
        aria-hidden
        className="absolute inset-0 w-full h-full object-contain pointer-events-none select-none"
        draggable={false}
      />
      <div className="absolute overflow-hidden" style={WINDOW}>
        {image && (
          <img
            src={image}
            alt={name}
            loading="lazy"
            className={`w-full h-full ${hoverZoom && !hasAdjust ? "group-hover:scale-110 transition-transform duration-500" : ""}`}
            style={{
              objectFit: fit,
              transform: `translate(${tx}%, ${ty}%) scale(${sc})`,
              transformOrigin: "center center",
              filter: "drop-shadow(0 12px 18px rgba(0,0,0,0.65))",
            }}
          />
        )}
      </div>
      {price != null && (
        <div className="absolute flex items-center justify-center" style={plate}>
          <div
            className="absolute"
            style={{
              ...plateBg,
              borderRadius: `${priceRadius ?? 2}cqw`,
              background: "linear-gradient(180deg, #E9C766 0%, #D4AF37 45%, #A9821F 100%)",
              boxShadow: "0 2px 10px rgba(0,0,0,0.55), inset 0 1px 0 rgba(255,255,255,0.35)",
              border: "1px solid rgba(60,40,5,0.55)",
            }}
            data-testid="framed-price-bg"
            aria-hidden
          />
          <span
            className="relative font-bold leading-none tracking-tight whitespace-nowrap"
            style={{ fontSize: `${4.5 * (priceScale || 1)}cqw`, transform: "scaleX(1.08)", color: priceColor }}
            data-testid="framed-price"
          >
            {price}
          </span>
        </div>
      )}
    </div>
  );
}
